import { processLazyPreloader } from '../../shared/process-lazy-preloader.js';
export default function onLoad(e) {
  const swiper = this;
  processLazyPreloader(swiper, e.target);
  swiper.update();
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/swiper/core/events/onLoad.js
// module id = Atqz
// module chunks = 13